import Styled from 'styled-components';

const Steps = Styled.div`
    
    .progress-wrapper {
        width: 100%;
        color: ${ (props) => props.theme.white };
        h3 {
            font-weight: bold;
            font-size: 30px;
            line-height: 21px;
            margin-top: 25px;
        }
        .progressbar {
            counter-reset: step;
            padding: 0;
            li {
                list-style-type: none;
                float: left;
                width: calc(25% - 14px);
                height: 10px;
                position: relative;
                text-align: left;
                margin-right: 14px;
                text-transform: capitalize;
                background: ${ (props) => props.theme.successDisable };
                border-radius: 38px;
                margin-top: 12px; 
                box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.15);
                font-weight: 500;
                font-size: 12px;
                line-height: 30px;
                color: ${ (props) => props.theme.success };
                &:last-child {
                    margin-right: 0;
                } 
                &.active {
                    background: ${ (props) => props.theme.success }; 
                    border: 3px solid ${ (props) => props.theme.successDisable };
                }              
            }
        }
    }
    @media (max-width: 575px){
        .progress-wrapper {
            h3 {
                line-height: 25px;
            }
        }
    }
`;

export default Steps